<label class="form-check-label user-select-none text-truncate" [for]="'switch-' + id">
    {{title}}
</label>
<input [disabled]="disabled" class="ms-auto form-check-input" type="checkbox" role="switch" [id]="'switch-' + id"
    [(ngModel)]="ngModelIn" (change)="ngModelInChange.emit($event.target.checked)"
    (change)="onChange.emit($event.target.checked)" style="cursor: pointer;">